// extracted by mini-css-extract-plugin
export default {"ResetPasswordSuccess":"restePasswordSuccess_ResetPasswordSuccess__lgltO","img":"restePasswordSuccess_img__SHUAG","resetPasssword":"restePasswordSuccess_resetPasssword__ly9jW"};